module.exports = __webpack_public_path__ + "img/motion02.e9d56a2c.jpg";